require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-divisare-features-our-grange-residence.json") })
        }
      }, "path---journal-divisare-features-our-grange-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-divisare-features-our-grange-residence!./.cache/json/journal-divisare-features-our-grange-residence.json
// module id = 479
// module chunks = 231608221292675